import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import {
  Box, AppBar, Toolbar, Typography,
  List, ListItem, ListItemButton, ListItemIcon, ListItemText,
  IconButton, CssBaseline
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import NotificationsIcon from '@mui/icons-material/Notifications';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import CategoryIcon from '@mui/icons-material/Category';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';

export default function Sidebar() {

  const [mode, setMode] = React.useState('light');
  const role = sessionStorage.getItem("role");
  const toggleMode = () => {
    setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  };

  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          ...(mode === 'light'
            ? {
                primary: { main: '#1976d2' },
                background: { default: '#f5f5f5' },
              }
            : {
                primary: { main: '#90caf9' },
                background: { default: '#121212' },
              }),
        },
      }),
    [mode]
  );

  const [data, setData] = useState({});
  
  useEffect(() => {
    const userid = sessionStorage.getItem("userid");
    const token = sessionStorage.getItem("token");
  
    if (!userid || !token) {
      console.log("User not logged in");
      return;
    }
  
    async function getAdminData() {
      try {
        const response = await fetch(
          "https://msdskserver.onrender.com/api/user/" + userid,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: token,
            },
          }
        );
  
        const result = await response.json();
        console.log(result);
  
        if (result.result === "Done") {
          setData(result.data);
        } else {
          console.log(result.message);
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    }
  
    getAdminData();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ display: 'flex' }}>
        {/* AppBar */}
        <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
          <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="h5" noWrap component="div">
              <img src="./assets/images/MSDSK.png" alt="" style={{height:"50px"}}/>
              MAA SHARDE DIGITAL SEVA KENDRA
            </Typography>
            <div className='d-flex'>
              <IconButton color="inherit" onClick={toggleMode}>
              {mode === 'light' ? <DarkModeIcon /> : <LightModeIcon />}
            </IconButton>
            <Stack className='px-3' direction="row" spacing={2}>
              <Avatar alt={data.name} src={`https://msdskserver.onrender.com/api/user/${data.pic}`} style={{height:"30px", width:"30px", marginTop:"5px"}}/>
            </Stack>
            </div>
          </Toolbar>
        </AppBar>

        {/* Sidebar */}
        <Box
          sx={{
            width: 220,
            flexShrink: 0,
            height: '100vh',
            bgcolor: 'background.default',
            pt: 8,
            borderRight:"1px solid #969696",
          }}
        >
          <List>
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/dashboard" >
                <ListItemIcon><DashboardIcon /></ListItemIcon>
                <ListItemText primary="Dashboard" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/admincategory" >
                <ListItemIcon><CategoryIcon /></ListItemIcon>
                <ListItemText primary="Categaory" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/notifaction" >
                <ListItemIcon><NotificationsIcon /></ListItemIcon>
                <ListItemText primary="Notifaction" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/request" >
                <ListItemIcon><RequestPageIcon /></ListItemIcon>
                <ListItemText primary="Request" />
              </ListItemButton>
            </ListItem>
            {
              role === "SuperAdmin" && (
                <ListItem disablePadding>
                <ListItemButton component={Link} to="/userpage" >
                <ListItemIcon><RequestPageIcon /></ListItemIcon>
                <ListItemText primary="User Details" />
                </ListItemButton>
               </ListItem>
              )
            }
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/contact" >
                <ListItemIcon><ContactPhoneIcon /></ListItemIcon>
                <ListItemText primary="Contact" />
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Box>
    </ThemeProvider>
  );
}
